/*  ==============================================
//  Created by nguyendx                          ||
//  create at: 2017-10-25                        ||
//===============================================*/
import {Component, EventEmitter, Injectable, Injector, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, NgForm} from '@angular/forms';
import {ActivatedRoute, Params} from '@angular/router';
import {UploadService} from '../../../../common/services/Upload.service';
import {ConfirmationService} from 'primeng/primeng';
import {EvsStoreService} from '../../../../common/services/EvsStore.service';
import {Location} from '@angular/common';
import {CategoryService} from '../../../../common/services/Category.service';
import {EvsAddressService} from '../../../../common/services/EvsAddress.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

declare var $: any;
var that: any;
@Component({
    moduleId: module.id,
    selector: 'store_edit',
    templateUrl: './store_edit.component.html',
    styleUrls: ['./store.css'],
    providers: [ConfirmationService, EvsStoreService, EvsAddressService]
})

@Injectable()
export class StoreEditComponent implements OnInit {
    @Input('itemId') itemId: any;
    @Output('backUpdate') backUpdate = new EventEmitter();
    public store: any = {};
    public message: { class: string, content: string } = null;
    public error: string = '';
    public cities: Array<any> = [];
    public districts: Array<any> = [];
    public componentData = null;
    public routerChange: any;

    public selectedStore: Array<string>;
    public id_store: number = 0;
    public translateMap: any = {};

    listType = [
        { id: 1, value: 1, label: 'DIEM_BAN' },
        { id: 2, value: 2, label: 'BAO_HANH' },
        { id: 3, value: 3, label: 'DIEM_BAN_BAO_HANH' }
    ];

    title: string = 'My first AGM project';
    lat: number = 51.678418;
    lng: number = 7.809007;

    constructor(private injector: Injector,
        private _location: Location,
        private storeService: EvsStoreService,
        public addressService: EvsAddressService,
        private upload: UploadService,
        private activatedRoute: ActivatedRoute,
        private cate: CategoryService,
        private _fb: FormBuilder,
        private toastr: ToastrService,
        private translate: TranslateService) {
        that = this;
    }

    ngOnInit() {
        this.translate.get(['CHON_KIEU_PLACEHOLDER', 'SELECT_PROVINCE_CITY', 'SELECT_DISTRICT']).subscribe((res) => {
            this.translateMap = res;
            this.initSelect2(this.translateMap);
        });

        this.translate.onLangChange.subscribe((event) => {
            this.translateMap = event.translations;
            this.initSelect2(this.translateMap);
        });

        this.routerChange = this.activatedRoute.params.subscribe((params: Params) => {
            //this.id_store = params['id'];
            this.id_store = this.itemId;
            this.getDetail(this.itemId);
        });
    }

    initSelect2(translations: any) {
        let typePlaceholder = translations['CHON_KIEU_PLACEHOLDER'] || "-- Chọn kiểu --";
        let provincePlaceholder = translations['SELECT_PROVINCE_CITY'] || "-- Chọn Tỉnh/TP --";
        let districtPlaceholder = translations['SELECT_DISTRICT'] || "-- Chọn Quận/Huyện --";

        $('#_type').select2({ placeholder: typePlaceholder, allowClear: false, width: '100%', minimumResultsForSearch: Infinity });
        $('#_province').select2({ placeholder: provincePlaceholder, allowClear: false, width: '100%' }).on("select2:select", function (e) {
            $(".select2-selection__rendered").removeAttr('title');
            var id = e.target.value;
            that.loadDistrictData(id);
        });
        $('#_district').select2({ placeholder: districtPlaceholder, allowClear: false, width: '100%' }).on("select2:select", function (e) {
            $(".select2-selection__rendered").removeAttr('title');
        });
    }

    getDetail(id) {
        this.storeService.getDetaiById(id).toPromise().then(res => {
            if (res) {
                if (!res.error) {
                    this.store = res.data;
                    this.selectedStore = [this.store.type];
                    this.getCity();
                    $('#_type').val(this.store.type).trigger('change');//set selected type
                    $('#_province').val(this.store.province).trigger('change')
                    $('#_district').val(this.store.district).trigger('change')
                } else {
                    this.message = { class: "alert dark alert-danger", content: 'Error: ' + res.message };
                }
            }
        },
            error => {
                this.message = { class: "alert dark alert-danger", content: 'Error: ' + error };
            });
    }

    backFromUpdate() {
        that.backUpdate.emit({
            isBack: true
        })
        //this._location.back();
    }

    getCity() {
        this.addressService.getCities().subscribe(res => {
            let citiesList = [];
            res.data.cities.forEach((c: any) => {
                citiesList.push({
                    value: c.name,
                    label: c.name,
                    id: c.id,
                });
                if (c.id == this.store.province) {
                    this.loadDistrictData(c.id);
                }
            });
            this.cities = citiesList;
        });
    }

    loadDistrictData(id: number) {
        this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
            let districts = [];
            res.data.districts.forEach((c: any) => {
                districts.push({
                    value: c.name,
                    label: c.name,
                    id: c.id,
                });
            });
            this.districts = districts;
        })
    }

    onSubmit(form: NgForm) {
        this.message = null;
        let objectData = {};

        let type = $('#_type option:selected').val();
        let province = $('#_province option:selected').val();
        let district = $('#_district option:selected').val();

        if (this.store.name.trim().length === 0)
            this.message = { class: "alert alert-danger", content: this.translate.instant('TEN_KHONG_DUOC_BO_TRONG') };
        // else if (!type)
        //     this.message = { class: "alert alert-danger", content: "Bạn chưa chọn loại điểm bán, bảo hành !" };
        else if (!province)
            this.message = { class: "alert alert-danger", content: this.translate.instant('BAN_CHUA_CHON_TINHTP') };
        else if (!district)
            this.message = { class: "alert alert-danger", content: this.translate.instant('BAN_CHUA_CHON_QUANHUYEN') };
        else if (this.store.address.trim().length === 0)
            this.message = { class: "alert alert-danger", content: this.translate.instant('DIA_CHI_KHONG_DUOC_BO_TRONG') };
        else {
            this.processSave();
            // this.store.province = $('#_province option:selected').text();
            // this.store.district = $('#_district option:selected').text();

            objectData = {
                "name": this.store.name,
                "type": type,
                "status": this.store.status,
                "province": province,
                "district": district,
                "address": this.store.address,
                "code": this.store.code
            };
            this.storeService.updateById(this.id_store, objectData).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        // this.message = {
                        //     class: "alert dark alert-danger",
                        //     content: res.status + ' : ' + res.message
                        // };
                        this.toastr.error(this.translate.instant('CAP_NHAT_THAT_BAI'), '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        // this.message = {
                        //     class: "alert dark alert-success",
                        //     content: "Cập nhật thành công !"
                        // };
                        this.toastr.info(this.translate.instant('CAP_NHAT_THANH_CONG'), '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.getDetail(this.id_store);
                    }
                    this.backUpdate.emit({
                        isBack: false
                    })
                    // form.reset();
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
        this.scrollToTop();
    }

    processSave() {
        this.message = {
            class: "alert dark alert-info",
            content: this.translate.instant('DANG_THUC_THI')
        };
    }

    scrollToTop() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/store_manager/store_edit.component.ts